import List from "@/components/list";
import router from "@/router";
import { tableBaseProps } from '@/utils/common.js';

const Table = (args) => {
  const { listeners, props } = args;
  const selectionChange = listeners["selectionChange"] || function () { };
  const download = listeners["download"] || function () { }

  function goClassDetail(offlineClass) {
    let query = { id: offlineClass.classId };
    if (offlineClass.classParentId) {
      query.parentId = offlineClass.classParentId
    }
    router.push({
      path: "offlineClass/detail",
      query: query,
    });
  }

  const Deal = ({ props: { vo } }) => {
    const item = vo.row;
    const dealConf = [
      ["iconfont ic_download iconfont-adapt", "下载", () => download(item), "admissionNotice:download"],
    ];
    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>)
  }

  const ClassName = ({ props: { vo } }) => {
    const offlineClass = vo.row;
    return (
      <span class="base-hover-char" onClick={() => goClassDetail(offlineClass)}>
        {offlineClass.className}
      </span>
    );
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
    },
    tableBaseProps("姓名", "userName", "100"),
    tableBaseProps("工作单位", "deptName", "m150"),
    tableBaseProps("单位及职务", "unitPosition", "m150"),
    {
      ...tableBaseProps("参加班级", "className", "m150"),
      render: (vo) => <ClassName vo={vo} />,
    },
    tableBaseProps("入学通知书", "fileName", "m150"),
    tableBaseProps("学员查看状态", "readName", "100"),
    tableBaseProps("学员下载状态", "downloadName", "100"),
    tableBaseProps("联络员下载状态", "liaisonDownloadName", "110"),
    tableBaseProps("发送时间", "createDate", "150"),
    {
      label: "操作",
      fixed: "right",
      width: "90",
      render: (vo) => <Deal vo={vo} />,
    },
  ]
  return <List {...args} talbeCols={AccountTableConfig} onSelectionChange={selectionChange} />;
}

export default Table;